import $foreign from "./foreign.cjs";
var unsafeStringify = $foreign.unsafeStringify;
export { unsafeStringify };
